import { FunctionComponent } from "react";

import { Box, Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import { useQuery } from "react-query";
import { useAppSelector } from "../../../../Config/Hooks";
import { RootState } from "../../../../Config/Store";
import { getInverterBox, getRelayBox, getSolarimetricBox, getTrackersBox } from "../../Synoptic/PowerStationSynopticCard";
import { QueryData, transformToDTO } from "../../Synoptic/SynopticPage";
import { fetchSynopticData } from "../../Synoptic/SynopticReactQuery";
import TotalizerCard from "../../../../Shared/Components/TotalizerCard/TotalizerCard";

const TotalizerSynoptic: FunctionComponent<{powerStationId: any}> = ({powerStationId}) => {

    const {selectedPowerPlant} = useAppSelector((state: RootState) => state.dashboard);
    const userConfig = useAppSelector((state: RootState) => state.userConfigurarion);
    const { enqueueSnackbar } = useSnackbar();
    
    const query = useQuery({
            queryKey: ['data', selectedPowerPlant.id],
            queryFn: () => fetchSynopticData(selectedPowerPlant.id),
            refetchInterval: userConfig.mainUpdateInterval,
            enabled: selectedPowerPlant.id > 0,
            onError: () => {
                enqueueSnackbar("Não foi possível buscar os dados. Tente novamente", {variant: 'error', autoHideDuration: 1500,})
            }
        })
    
    const queryState : QueryData = query.isSuccess && query.data?.data ?
            { status: 'success', data: transformToDTO(query.data.data) } :
            query.isLoading ? { status: 'loading' }:
            query.isError ? { status: 'error', error: query.error }:
            { status: 'idle' };

    const stateData = queryState.data;
    const inverter = stateData && stateData.powerStation ? stateData.powerStation.inverter : null;
    const relay = stateData && stateData.powerStation? stateData.powerStation.relay : null;
    const solarimetric = stateData && stateData.powerStation ? stateData.powerStation.solarimetric : null;
    const trackers = stateData && stateData.powerStation? stateData.powerStation.trackers : null;

    return (
        <Box>
            <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid item style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', padding: '0 16px 16px 0px' }} xs={12} sm={6} md={6} lg={3} xl={3}>

                    <TotalizerCard
                        title="Inversores"
                        iconBox={inverter && getInverterBox(inverter)}
                        items={[
                            { label: 'Alarme crítico', count: inverter?.stoppedCount },
                            { label: 'Alarme médio ou alto', count: inverter?.highCount },
                            { label: 'Sem comunicação', count: inverter?.withoutCommunicationCount },
                        ]}
                    />
                </Grid>

                <Grid item style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', padding: '0 16px 16px 0px' }} spacing={2} xs={12} sm={6} md={6} lg={3} xl={3}>

                    <TotalizerCard
                        title="Relés"
                        iconBox={relay && getRelayBox(relay)}
                        items={[
                            { label: 'Alarme crítico', count: relay?.stoppedCount },
                            { label: 'Alarme médio ou alto', count: relay?.highCount },
                            { label: 'Sem comunicação', count: relay?.withoutCommunicationCount },
                        ]}
                    />
                </Grid>
                <Grid item style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', padding: '0 16px 16px 0px' }} spacing={2} xs={12} sm={6} md={6} lg={3} xl={3}>

                    <TotalizerCard
                        title="Solarimétrica"
                        iconBox={solarimetric && getSolarimetricBox(solarimetric)}
                        items={[
                            { label: 'Alarme crítico', count: solarimetric?.stoppedCount },
                            { label: 'Alarme médio ou alto', count: solarimetric?.highCount },
                            { label: 'Sem comunicação', count: solarimetric?.withoutCommunicationCount },
                        ]}
                    />
                </Grid>
                <Grid item style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', padding: '0 0 16px 0px' }} xs={12} sm={6} md={6} lg={3} xl={3}>

                    <TotalizerCard
                        title="Trackers"
                        iconBox={trackers && getTrackersBox(trackers)}
                        items={[
                            { label: 'Alarme crítico', count: trackers?.stoppedCount },
                            { label: 'Alarme médio ou alto', count: trackers?.highCount },
                            { label: 'Sem comunicação', count: trackers?.withoutCommunicationCount },
                        ]}
                    />
                </Grid>
                 
            </Grid>

        </Box>
    )

}

export default TotalizerSynoptic;